import { render, staticRenderFns } from "./u-pagination-filled-rounded.vue?vue&type=template&id=825a7156&scoped=true&"
import script from "./u-pagination-filled-rounded.vue?vue&type=script&lang=js&"
export * from "./u-pagination-filled-rounded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "825a7156",
  null
  
)

export default component.exports